'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _modal = require('redux/actions/modal');

var _coupons = require('redux/actions/coupons');

var _helpers = require('helpers');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _basket = require('redux/actions/basket');

var _registration = require('redux/actions/registration');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponSearchModal = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.auth.user,
        shopId: state.setting.shopId,
        preload: state.coupons.preload,
        preloadAuth: state.auth.preload,
        lang: state.lang
    };
}, { couponsSearch: _coupons.couponsSearch, hide: _modal.hide, addCouponInBasket: _basket.addCouponInBasket, confirmRegistrationOneClick: _registration.confirmRegistrationOneClick, registrationOneClick: _registration.registrationOneClick }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(CouponSearchModal, _BaseForm);

    function CouponSearchModal(props, context) {
        (0, _classCallCheck3.default)(this, CouponSearchModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CouponSearchModal.__proto__ || (0, _getPrototypeOf2.default)(CouponSearchModal)).call(this, props, context));

        _this.handlerChangeInput = function (event) {
            _this.setState({
                token: event.target.value
            });
        };

        _this.onSearch = function () {
            if (_this.props.user) {
                _this.props.couponsSearch(_this.state.token, _this.props.user.id).then(function (result) {
                    if (result === null || result.coupon === null) {
                        var alertMessage = _this.props.lang['store.iBonus.modals.couponNotFound'];
                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
                    } else {
                        _this.props.addCouponInBasket({
                            description: result.coupon.offer.description,
                            id: result.coupon.offer.id,
                            name: result.coupon.offer.name,
                            price: parseFloat(0),
                            picture: result.coupon.imagePath,
                            count: 1,
                            type_id: result.coupon.offer.type_id,
                            modifier_option_id: result.coupon.modifier_option_id !== undefined ? result.coupon.modifier_option_id : null,
                            modifier_option: result.coupon.modifiedOption !== undefined ? result.coupon.modifiedOption : null,
                            remainder_quantity: 1,
                            is_coupon: true,
                            coupon_id: result.coupon.id,
                            coupon_token: _this.state.token,
                            customer_coupon_id: _this.state.customer_coupon_id
                        });
                        var _alertMessage = _this.props.lang['store.iBonus.modals.couponAddedToCart'];
                        _reactSAlert2.default.success(_alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
                        _this.props.hide();
                    }
                });
            } else {
                _this.props.couponsSearch(_this.state.token).then(function (result) {
                    if (result === null) {
                        var alertMessage = _this.props.lang['store.iBonus.modals.couponNotFound'];
                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
                    } else {
                        if (result.phone !== undefined || result.email !== undefined) {
                            _this.setState({ newUser: result.new_user });
                            if (result.send_for_phone) {
                                _this.setState({ codeSendFor: 'phone' });
                                _this.setState({ login: result.phone });
                            } else if (result.send_for_email) {
                                _this.setState({ codeSendFor: 'email' });
                                _this.setState({ login: result.email });
                            }
                            _this.setState({ timeToResentCode: 60 });
                            _this.setState({ coupon: result.coupon });
                            var timerId = setInterval(function () {
                                _this.setState({ timeToResentCode: _this.state.timeToResentCode - 1 });
                            }, 1000);
                            setTimeout(function () {
                                clearInterval(timerId);
                            }, 60000);
                        } else {
                            _this.props.addCouponInBasket({
                                description: result.coupon.offer.description,
                                id: result.coupon.offer.id,
                                name: result.coupon.offer.name,
                                price: parseFloat(0),
                                picture: result.coupon.imagePath,
                                count: 1,
                                type_id: result.coupon.offer.type_id,
                                modifier_option_id: result.coupon.modifier_option_id !== undefined ? result.coupon.modifier_option_id : null,
                                modifier_option: result.coupon.modifiedOption !== undefined ? result.coupon.modifiedOption : null,
                                remainder_quantity: 1,
                                is_coupon: true,
                                coupon_id: result.coupon.id,
                                coupon_token: _this.state.token,
                                customer_coupon_id: _this.state.customer_coupon_id
                            });
                            var _alertMessage2 = _this.props.lang['store.iBonus.modals.couponAddedToCart'];
                            _reactSAlert2.default.success(_alertMessage2, { position: 'top-right', effect: 'slide', timeout: 3000 });
                            _this.props.hide();
                        }
                    }
                });
            }
        };

        _this.closeModal = function () {
            _this.props.hide();
        };

        _this.onClickConfirmOneClick = function (event) {
            _this.props.confirmRegistrationOneClick({
                shopId: _this.props.shopId,
                login: _this.state.login,
                emailCode: _this.state.emailCode,
                smsCode: _this.state.phoneCode
            }).then(function (result) {
                _this.props.addCouponInBasket({
                    description: _this.state.coupon.offer.description,
                    id: _this.state.coupon.offer.id,
                    name: _this.state.coupon.offer.name,
                    price: parseFloat(0),
                    picture: _this.state.coupon.imagePath,
                    count: 1,
                    type_id: _this.state.coupon.offer.type_id,
                    modifier_option_id: _this.state.coupon.modifier_option_id !== undefined ? _this.state.coupon.modifier_option_id : null,
                    modifier_option: _this.state.coupon.modifiedOption !== undefined ? _this.state.coupon.modifiedOption : null,
                    remainder_quantity: 1,
                    is_coupon: true,
                    coupon_id: _this.state.coupon.id,
                    coupon_token: _this.state.token,
                    customer_coupon_id: _this.state.customer_coupon_id
                });
                var alertMessage = _this.props.lang['store.iBonus.modals.couponAddedToCart'];
                _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
                _this.props.hide();
            });
        };

        _this.onClickResendCode = function (event) {
            _this.props.registrationOneClick({ shopId: _this.props.shopId, login: _this.state.login }).then(function (result) {
                _this.setState({ timeToResentCode: 60 });
                var timerId = setInterval(function () {
                    _this.setState({ timeToResentCode: _this.state.timeToResentCode - 1 });
                }, 1000);
                setTimeout(function () {
                    clearInterval(timerId);
                }, 60000);
            });
        };

        _this.state = {
            token: '',
            login: '',
            codeSendFor: '',
            timeToResentCode: 0,
            coupon: null
        };
        return _this;
    }

    (0, _createClass3.default)(CouponSearchModal, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('CouponSearchModal', null, { folderName: "Search/CouponSearchModal" });

            return _react2.default.createElement(View, (0, _extends3.default)({}, this.props, {
                closeModal: this.closeModal,
                token: this.state.token,
                coupon: this.state.coupon,
                onChange: this.handlerChangeInput,
                onSubmit: this.onSearch,
                preload: this.props.preload || this.props.preloadAuth,
                onClickConfirmOneClick: this.onClickConfirmOneClick,
                codeSendFor: this.state.codeSendFor,
                login: this.state.login,
                timeToResentCode: this.state.timeToResentCode,
                onClickResendCode: this.onClickResendCode,
                changeField: this.changeField,
                lang: this.props.lang
            }));
        }
    }]);
    return CouponSearchModal;
}(_BaseForm3.default), _class2.propTypes = {
    hide: _react.PropTypes.func.isRequired,
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = CouponSearchModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/CouponSearchModal/CouponSearchModal.jsx
// module id = 1761
// module chunks = 0